import { useEffect } from 'react';
import { Button } from '@/components/ui/button';

type UndoBarProps = { message: string; onUndo: () => void; onDismiss: () => void };

const DISMISS_AFTER_MS = 8000;

/** A short note under the grid after a bulk action, with a way back; goes away by itself. */
export function UndoBar({ message, onUndo, onDismiss }: UndoBarProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, DISMISS_AFTER_MS);
    return () => clearTimeout(timer);
  }, [message, onDismiss]);

  return (
    <div role="status" className="no-print flex items-center gap-2 text-sm">
      <span>{message}</span>
      <Button variant="link" className="h-auto min-h-11 p-0" onClick={onUndo}>
        Ongedaan maken
      </Button>
    </div>
  );
}
